import { api } from '../client';
import type { UUID } from '@/types/domain';

/** Active or retired — the status HR's configuration records carry. */
export type DepartmentStatus = 'ACTIVE' | 'INACTIVE';

/** A part of the school someone works in. Mirrors the backend's DepartmentResponse. */
export interface Department {
  id: UUID;
  schoolId: UUID;
  code: string;
  name: string;
  description?: string;
  campusId?: UUID;
  campusName?: string;
  managerEmployeeId?: UUID;
  managerName?: string;
  headcount: number;
  positionCount: number;
  status: DepartmentStatus;
  createdAt: string;
  updatedAt: string;
}

/*
 * The school's departments, under DEPARTMENT_VIEW. Not paged: the server
 * returns the whole list (provisioning defaults on first read).
 */
export const departmentsApi = {
  list: (activeOnly = false) =>
    api.get<Department[]>('/departments', { params: { activeOnly } }),
};
